import axios from 'lib/axios'

const basePath = '/api/v1/reports'

export const ReportServiceV1 = {
  generateSsmReport: async () => {
    return axios.post(`${basePath}/ssm`)
  },
  generateExecutiveReport: async () => {
    return axios.post(`${basePath}/executive-report`)
  },
  downloadReport: (ssmReportCode: string) => {
    return axios.get(`${basePath}/download_url/${ssmReportCode}`)
  }
}
